import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import {
  getStockSettingsThunk,
  setStockSettingsThunk,
} from "store/reducers/inventory/stock/inventorySettingsSlice";
import * as yup from "yup";

const validation = yup.object({
  stock_level: yup.string("Enter stock_level").required(),
  enable_filling_person_stock: yup.boolean().required("Field is mandatory"),
});

const InventorySettings = () => {
  useEffect(() => {
    dispatch(getStockSettingsThunk());
  }, []);
  const state = useSelector((state) => state.inventorySettings);
  const formik = useFormik({
    initialValues: {
      stock_level: state?.data?.stock_level ?? "super_admin",
      enable_filling_person_stock:
        state?.data?.enable_filling_person_stock ?? false,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      dispatch(setStockSettingsThunk(data));
    },
    validateOnChange: false,
  });
  return (
    <Box padding={3}>
      {state.data ? (
        <>
          <Typography variant="h6">Current settings</Typography>
        </>
      ) : (
        <>
          <Typography variant="h5">Please configure settings</Typography>
        </>
      )}
      <form onSubmit={formik.handleSubmit} >
        <Grid container columnSpacing={2} rowSpacing={0} sx={{mt:2}}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Stock level"
              variant="outlined"
              name="stock_level"
              select
              fullWidth
              value={formik.values.stock_level}
              onChange={formik.handleChange("stock_level")}
              error={Boolean(formik.errors.stock_level)}
              helperText={formik.errors.stock_level}
              autoComplete="new-password"
            >
              <MenuItem value={"super_admin"}>Super Admin</MenuItem>
              <MenuItem value={"admin"}>Admin</MenuItem>
              <MenuItem value={"location"}>Location</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Enable filling person stock"
              variant="outlined"
              name="enable_filling_person_stock"
              select
              fullWidth
              value={formik.values.enable_filling_person_stock}
              onChange={formik.handleChange("enable_filling_person_stock")}
              error={Boolean(formik.errors.enable_filling_person_stock)}
              helperText={formik.errors.enable_filling_person_stock}
              autoComplete="new-password"
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </TextField>
          </Grid>
        </Grid>
        {state.error?.post && (
          <Alert sx={{ my: 1 }} severity="error">
            Error occurred
          </Alert>
        )}

        {state.success?.post && (
          <Alert sx={{ my: 1 }} severity="success">
            Success
          </Alert>
        )}
        <LoadingButton
          loading={state.loading?.post}
          variant="contained"
          type="submit"
          sx={{ paddingX: 10, marginTop: 1 }}
        >
          {state?.data ? "Update" : "Create"}
        </LoadingButton>
      </form>
    </Box>
  );
};

export default InventorySettings;
